import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../SidebarItem";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {Authorizations, hasAuthorization} from "utils/authorizations";

import {SidebarContext} from "../../../../../SidebarContext";

RetailerFeedsItem.propTypes = {
    retailerId: PropTypes.string.isRequired
};

function RetailerFeedsItem({retailerId}) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.MARKETPLACE_FEED_MANAGEMENT)) {
        return null;
    }

    return (
        <SidebarItem
            to={MarketplaceRoutes.RETAILER_FEEDS(retailerId)}
            selected={currentPath.includes(MarketplaceRoutes.RETAILER_FEEDS(retailerId))}
        >
            <FormattedMessage id='sidebar.item.feeds' />
        </SidebarItem>
    );
}

export default RetailerFeedsItem;
